import dayjs from 'dayjs';
import { useEffect } from 'react';

import { actualizeLeadsRegistryDynamicDates } from './useLeadsRegistryFilters';

// Keeps preset-driven periods in sync with the calendar day for a tab that is
// never reloaded. Two triggers are required: a timer to the nearest midnight
// covers a tab left open and visible, while visibilitychange/focus cover
// background tabs, where browsers throttle timers indefinitely.
export const useLeadsRegistryDateRollover = () => {
  useEffect(() => {
    let timerId: number | undefined;

    const scheduleMidnightTick = () => {
      const now = dayjs();
      // The extra second guards against the timer firing a moment before
      // midnight due to clock rounding and resolving the old day again.
      const delay = now.add(1, 'day').startOf('day').diff(now) + 1_000;
      timerId = window.setTimeout(() => {
        actualizeLeadsRegistryDynamicDates();
        scheduleMidnightTick();
      }, delay);
    };

    const wakeHandler = () => {
      actualizeLeadsRegistryDynamicDates();
    };

    scheduleMidnightTick();
    document.addEventListener('visibilitychange', wakeHandler);
    window.addEventListener('focus', wakeHandler);

    return () => {
      window.clearTimeout(timerId);
      document.removeEventListener('visibilitychange', wakeHandler);
      window.removeEventListener('focus', wakeHandler);
    };
  }, []);
};
